import React from 'react';
import { Link } from 'react-router-dom';
import './breadcrumbs.scss';

export type BreadcrumbItem = {
    label: string;
    to?: string; // если нет ссылки - элемент рендерится как текст
    ariaLabel?: string;
};

type Props = {
    items: BreadcrumbItem[];
    className?: string;
    'data-testid'?: string;
};

const Breadcrumbs: React.FC<Props> = ({ items, className, ...rest }) => {
    if (!Array.isArray(items) || items.length === 0) return null;

    return (
        <nav className={`breadcrumbs ${className || ''}`.trim()} aria-label="Хлебные крошки" itemScope itemType="https://schema.org/BreadcrumbList" {...rest}>
            <ol className="breadcrumbs__list">
                {items.map((item, idx) => {
                    const isLast = idx === items.length - 1;
                    const position = idx + 1;

                    return (
                        <li key={`${item.label}-${idx}`} className="breadcrumbs__item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                            {item.to && !isLast ? (
                                <Link to={item.to} className="breadcrumbs__link" itemProp="item" aria-label={item.ariaLabel || item.label}>
                                    <span itemProp="name">{item.label}</span>
                                </Link>
                            ) : (
                                <span className={`breadcrumbs__current${isLast ? ' is-last' : ''}`} itemProp="name" aria-current="page">
                                    {item.label}
                                </span>
                            )}
                            <meta itemProp="position" content={String(position)} />
                            {!isLast && (
                                <span className="breadcrumbs__sep" aria-hidden="true">
                                    |
                                </span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;
